// src/components/Header.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import { Show, UserButton } from "@clerk/react";
import usePaidPlan from '../hooks/usePaidPlan';

const Header = ({ searchTerm, onSearchChange, showSearch = false }) => {
  const { hasPaidPlan } = usePaidPlan();

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="site-name-link">
          <span className="site-name"><span style={{ color: '#000' }}>Bidder</span> iQ</span>
        </Link>
        {showSearch && (
          <div className="header-search-container">
            <input
              type="text"
              placeholder="Search models, years, VIN..."
              value={searchTerm}
              onChange={onSearchChange}
              className="header-search-input"
            />
          </div>
        )}
        <div style={{ marginLeft: 'auto', marginRight: '40px', display: 'flex', alignItems: 'center', gap: '20px' }}>
          <Show when="signed-in">
            {hasPaidPlan && (
              <a
                href="https://bidderiq.com/profile"
                style={{
                  textDecoration: 'none',
                  color: '#333',
                  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                  fontSize: '16px',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                Profile
              </a>
            )}
            <UserButton />
          </Show>
          <Show when="signed-out">
            <Link to="/sign-in" style={{ 
              textDecoration: 'none', 
              color: '#333', 
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
              fontSize: '16px',
              fontWeight: '500',
              cursor: 'pointer'
            }}>
              Sign In
            </Link>

          </Show>
        </div>
      </div>
    </header>
  );
};

export default Header;
